import React, { useMemo, FC } from 'react';
import { t } from 'i18next';

import { CampaignScheduling } from 'Store/entities/activity/activity.type';
import SLargeRadio from 'Components/structural/SLargeRadio/SLargeRadio';
import SInput from 'Components/structural/SInput/SInput';

import { sharedPanelFormStyles } from '../SchedulePanel.style';

export type ScheduleTypeFormProps = {
  currentType: CampaignScheduling['type'];
  extraDays: CampaignScheduling['extraDays'];
  onTypeChange: (type: CampaignScheduling['type']) => void;
  onExtraDaysChange: (extraDays: CampaignScheduling['extraDays']) => void;
};

const MAX_NUM_EXTRA_DAYS = 1000;

export const ScheduleTypeForm: FC<ScheduleTypeFormProps> = ({
  currentType,
  extraDays,
  onExtraDaysChange,
  onTypeChange,
}) => {
  const largeRadioItems = useMemo(
    () => [
      {
        id: 'flexible',
        text: t('activities:scheduling.side_panel.schedule_flexible'),
        tooltip: t('activities:scheduling.side_panel.schedule_flexible_tooltip'),
        delay: 1000,
        style: { display: 'flex', justifyContent: 'center' },
        hideIcon: true,
      },
      {
        id: 'intense',
        text: t('activities:scheduling.side_panel.schedule_intense'),
        tooltip: t('activities:scheduling.side_panel.schedule_intense_tooltip'),
        delay: 1000,
        style: { display: 'flex', justifyContent: 'center' },
        hideIcon: true,
      },
    ],
    [],
  );

  const handleExtraDaysChange = (value: string) => {
    const number = parseInt(value, 10);
    const days = Number.isInteger(number) ? Math.min(MAX_NUM_EXTRA_DAYS, Math.max(0, number)) : 0;

    onExtraDaysChange(days);
  };

  const handleTypeChange = (id: string) => {
    onTypeChange(id as CampaignScheduling['type']);
  };

  return (
    <div style={sharedPanelFormStyles.box}>
      <h4 style={sharedPanelFormStyles.title}>{t('activities:scheduling.side_panel.schedule_mode')}</h4>

      <div style={sharedPanelFormStyles.contentElement}>
        <SLargeRadio items={largeRadioItems} activeItemId={currentType} onClick={handleTypeChange} />
      </div>

      {currentType === 'flexible' ? (
        <div style={{ ...sharedPanelFormStyles.element, display: 'flex', alignItems: 'center' }}>
          <SInput
            style={sharedPanelFormStyles.input}
            extraInputStyle={sharedPanelFormStyles.internalInputStyle}
            type="mini"
            value={extraDays?.toString() || ''}
            placeholder="0"
            onChange={handleExtraDaysChange}
          />
          {t('activities:scheduling.side_panel.extra_playable_days_label')}
        </div>
      ) : null}
    </div>
  );
};
